import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';

const SECTIONS = [
    { path: '/admin', label: 'Resumen' },
    { path: '/admin/usuarios', label: 'Usuarios' },
    { path: '/admin/partidas', label: 'Partidas' },
    { path: '/admin/sugerencias', label: 'Sugerencias' },
    { path: '/admin/notificaciones', label: 'Notificaciones' },
    { path: '/admin/errores', label: 'Errores' },
    { path: '/admin/rankings', label: 'Rankings' },
    { path: '/admin/estadisticas', label: 'Estadísticas de uso' },
    { path: '/admin/configuracion', label: 'Configuración' },
];

/** Tab bar shared by every admin screen — same repeated-per-screen pattern as <Header>. */
export default function AdminNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const current = SECTIONS.some((s) => s.path === location.pathname) ? location.pathname : false;

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
            <Tabs
                value={current}
                onChange={(_e, value) => navigate(value)}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
            >
                {SECTIONS.map((section) => (
                    <Tab key={section.path} value={section.path} label={section.label} />
                ))}
            </Tabs>
        </Box>
    );
}
